const root = 'signup-signUpForm'

export const TestId = {
  profileTypeInput: `${root}-profileTypeInput`,
  retailerProfileTypeTile: `${root}-retailerProfileTypeTile`,
  supplierProfileTypeTile: `${root}-supplierProfileTypeTile`,
  emailInput: `${root}-emailInput`,
  passwordInput: `${root}-passwordInput`,
  businessNameInput: `${root}-businessNameInput`,
  countryInput: `${root}-countryInput`,
  onlineChannelsOtherInput: `${root}-onlineChannelsOtherInput`,
  onlineChannelTile: name => `${root}-${name}OnlineChannelTile`,
  submitButton: `${root}-SubmitButton`,
}
